// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"be7161ba","213":"8c54dc4d","370":"4253df3e","455":"6e36eb62","627":"309f3bb3","946":"2512a375","989":"6c96eb41"}[chunkId] + ".chunk.js";
};